import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./index.css";
import Navbar from "./components/Navbar/Navbar";
import Hero from "./components/Hero/Hero";
import Footer from "./components/Footer/Footer";
import BusinessSolutions from "./components/BusinessSolutions/BusinessSolutions";
import ScrollToTop from "./components/ScrollToTop";
import Marketing from "./components/Marketing/Marketing";
import ContactUs from "./components/ContactUs/ContactUs";
import FreeConsultation from "./components/FreeConsultation/FreeConsultation";
import Consulting from "./components/Consulting/Consulting";
import ConstructionInterior from "./components/ConstructionInterior/ConstructionInterior";
const App = () => {
  return (
    <Router>
      <Navbar />
      <ScrollToTop />
      <div className="app-container">
        <Routes>
          <Route path="/" element={<Hero />} />
          <Route path="/business-solutions" element={<BusinessSolutions />} />
          <Route path="/marketing" element={<Marketing />} />
          <Route path="/consulting" element={<Consulting />} />
          <Route
            path="/construction-interior"
            element={<ConstructionInterior />}
          />
          <Route path="/contact-us" element={<ContactUs />} />
          <Route path="/free-consultation" element={<FreeConsultation />} />
          {/* Add more routes as needed */}
        </Routes>
        <Footer />
      </div>
    </Router>
  );
};

export default App;
